export const SUPPORT_URL =
  'https://support.acorns.com/hc/en-us/articles/How-do-I-contact-Acorns'
export const APP_STORE_URL =
  'https://itunes.apple.com/us/app/acorns-invest-spare-change/id883324671'
export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.acorns.android'
export const SUPPORT_PHONE_NUMBER = '(855) 739-2859'
export const CORE_ACCOUNT_TYPE_NAME = 'InvestmentAccount::Basic'
export const TERMS_URL = 'https://www.acorns.com/terms/'
export const GOLD_TIER_DEFAULT_NAME = 'Gold'
export const AMPLITUDE_EXPERIMENT_CONTROL = 'control'
export const AMPLITUDE_EXPERIMENT_VARIATION_1 = 'v1'
